export default __webpack_public_path__ + "static/05_explore-schemas-f4cd96c6d15f13a90c5cad31ad82834a.png";